import { useSubscription } from '@apollo/client';
import { isEmpty } from 'lodash';
import React, { useCallback } from 'react';
import { Grid } from '@mui/material';
import { gridSpacing } from '../../common/themes/constants';
import ReferralNotesTable from '../referral/tables/ReferralNotesTable';
import PublicCreateReferralNote from './PublicCreateReferralNote';
import { GET_PUBLIC_REFERRAL_NOTES_BY_UUID } from './gql/Query';

export default function PublicReferralExternalNotes({ referralUUID, email, code, name="",isFax=false }) {
  const { loading, data } = useSubscription(GET_PUBLIC_REFERRAL_NOTES_BY_UUID, {
    variables: {
      uuid: referralUUID,
    },
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'network-only',
  });

  const handleOnSelectedRowsChanged = useCallback(selectedRows => {
  }, []);

  const handleFilterChanged = useCallback(e => {
  }, []);

  return (
    <Grid container spacing={gridSpacing} sx={{marginTop: '12px'}}>
        <Grid item md={12} xs={12}>
            <PublicCreateReferralNote referralId={referralUUID} 
                        email={email}
                        code={code}
                        isFax={isFax}/>
        </Grid>

        <Grid item md={12} xs={12}>
            <ReferralNotesTable
                onFilterChanged={handleFilterChanged}
                onSelectedRowsChanged={handleOnSelectedRowsChanged}
                loading={loading}
                data={
                    !isEmpty(data) && !loading
                    ? { rows: data.rows.filter(i => { return i.group.name === 'external'}).map(i=> {i.clinic=name; return i;}), count: data.rows.filter(i => { return i.group.name === 'external'}).count }
                    : { rows: [], count: 0 }
                }
            />
        </Grid>
    </Grid>
    
  );
}
